import { getMapNode } from "../../content/stages.js";
import type { NodeId, RunState } from "../types/index.js";
import { finishCaseCards } from "./caseCards.js";

export function advanceMap(run: RunState, nodeId: NodeId): RunState {
  const node = getMapNode(run.stageId, nodeId);
  if (!node) return run;

  const clearedNodeIds = run.clearedNodeIds.includes(nodeId)
    ? run.clearedNodeIds
    : [...run.clearedNodeIds, nodeId];

  return {
    ...run,
    currentNodeId: nodeId,
    clearedNodeIds,
    availableNodeIds: [...node.next],
  };
}

export function finishNode(run: RunState, nodeId: NodeId): RunState {
  return { ...advanceMap(finishCaseCards(run), nodeId), activeCase: null };
}
